// Format coin name to be standardized
// e.g. Australian Dollar (AUD) => Austalian Dollar
// e.g. Ethereum (ETH) => Ethereum

const removeSquareBrackets = / *\[[^\]]*]/;
const removeCurvedBrackets = / *\([^)]*\) */g;

const formatCoinName = (coinName: string, capitalizeFirst?: boolean): string => {
  let formattedName = coinName.replace(removeCurvedBrackets, "").replace(removeSquareBrackets, "");
  if (capitalizeFirst) {
    return formattedName.charAt(0).toUpperCase() + formattedName.slice(1);
  } else {
    return formattedName;
  }
};

export default formatCoinName;
